/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { GlobalState } from '../../actions';
import { albumListState } from '../selectors';

export const albumListSearchString = (state: GlobalState) => albumListState(state).albumSearch;

export const albumListSelector = (state: GlobalState) => albumListState(state).albumList;

export const albumSearchCount = (state: GlobalState) => albumListState(state).albumSearchCount;

export const albumSearchCurrentPos = (state: GlobalState) => albumListState(state).albumSearchCurrentPos;

export const albumSearchPageSize = (state: GlobalState) => albumListState(state).albumSearchPageSize;